import { useSyncExternalStore } from 'react'

export type ThemePreference = 'light' | 'dark' | 'system'
const KEY = 'bp_theme'
const listeners = new Set<() => void>()

function read(): ThemePreference {
  try {
    const v = localStorage.getItem(KEY)
    return v === 'light' || v === 'dark' ? v : 'system'
  } catch {
    return 'system'
  }
}

let current: ThemePreference = read()

/** Applies the preference to <html data-theme>; "system" removes it so the media query decides. */
export function applyTheme(pref: ThemePreference = current) {
  const el = document.documentElement
  if (pref === 'system') delete el.dataset.theme
  else el.dataset.theme = pref
}

function setTheme(pref: ThemePreference) {
  current = pref
  try {
    if (pref === 'system') localStorage.removeItem(KEY)
    else localStorage.setItem(KEY, pref)
  } catch {
    /* private mode */
  }
  applyTheme(pref)
  for (const l of listeners) l()
}

export function useTheme(): [ThemePreference, (p: ThemePreference) => void] {
  const pref = useSyncExternalStore(
    (cb) => {
      listeners.add(cb)
      return () => listeners.delete(cb)
    },
    () => current,
    () => 'system' as const,
  )
  return [pref, setTheme]
}
